import { TrackingService } from './../../../../services/tracking-service/tracking.service';
import { MarketplaceFilterInterface } from 'src/app/model/marketplace/marketplace-filter-interface';
import { debounceTime, map, startWith, take, tap } from 'rxjs/operators';
import { ChangeDetectorRef, Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MarketplaceFilterService } from 'src/app/services/componentServices/marketplace-filter-service/marketplace-filter.service';
import { MarketplaceCheckbox, CheckBoxCategorie } from 'src/app/model/marketplace/marketplace-checkbox';
import { MarketplaceService } from 'src/app/services/dataServices/marketplace-service/marketplace.service';
import { DataType } from 'src/app/model/data-type.enum';
import { FilterCheckboxDtoInterface } from 'src/app/model/marketplace/filter-checkbox-interface';
import { ProductCategory } from 'src/app/model/enums/productCategory';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { OrganisationType } from 'src/app/model/enums/organisationType';
import { CertificationTypes } from 'src/app/model/enums/certificationTypes';
import { SortMethod } from 'src/app/model/enums/SortMethod';
import { CertificationService } from 'src/app/services/dataServices/certification-service/certificationService';
import { CertificationOverviewInterface } from 'src/app/model/marketplace/certification-overview-interface';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { BehaviorSubject, Observable, of, Subscription, Unsubscribable } from 'rxjs';
import { FilterCommonFeature } from 'src/app/model/marketplace/filter-common-feature';
import { FilterCommonFeatureEntry } from 'src/app/model/marketplace/filter-common-feature-entry';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { FilterOrganisationProduct } from 'src/app/model/marketplace/filter-organisationProduct';
import { FilterOrganisationCertification } from 'src/app/model/marketplace/filter-organisationCertification';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FilterProductCategory } from 'src/app/model/marketplace/filter-product-category';
import { UntypedFormControl } from '@angular/forms';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';

@Component({
    selector: 'app-market-place-side-filter',
    animations: [
        trigger('openClose', [
            state('open', style({
                height: AUTO_STYLE
            })),
            state('closed', style({
                height: '0'
            })),
            transition('* => *', [animate('0.2s ease-out')])
        ])
    ],
    templateUrl: './market-place-side-filter.component.html',
    styleUrls: ['./market-place-side-filter.component.scss'],
    standalone: false
})
export class MarketPlaceSideFilterComponent implements OnInit, OnDestroy {
    public queryParamSubscription: Subscription;

    @Input()
    filterReset: boolean = false;
    filterString: string[] = [];

    @Input() externalSearch$?: Observable<string>;
    @Output() activeFiltersChange = new EventEmitter<MarketplaceFilterInterface>();
    @Output() resetAll = new EventEmitter<void>();

    fachPlanerEntries: FilterCommonFeatureEntry[] = [];
    fachPlanerId = 126;
    ptgCategory: { [id: string]: string } = {};
    public prodControl = new UntypedFormControl();
    filteredOptions: Observable<string[]>;
    public marketScreenState: DataType; //MarketScreenState.Products;
    public productCategoryScreenState: string[];
    private dataTypeEnum = DataType;
    public changeDetected: boolean = false;
    public subscription: Subscription;
    public filterSubscription: Subscription;
    public showProviderFilter: boolean = false;
    public showSecondProviderFilter: boolean = false;
    public providerFilterString: string = '';
    public secondProviderFilterString: string = '';
    public showProducttypeFilter: boolean = false;

    public minimiseProductKategorie: boolean = false;
    public minimiseZert: boolean = false;
    public minimiseProductTypen: boolean = false;
    public minimiseBewertungen: boolean = false;
    public minimiseAnbieter: boolean = false;

    public producttypeFilterString: string = '';
    public sortOptions = [{ name: SortMethod.ALPHABETICAL_ASC, title: 'Produktname' }, { name: SortMethod.ORGANISATION, title: 'Anbieter' }];
    public sortOrder = SortMethod.ALPHABETICAL_ASC;
    public commonFeatures: FilterCommonFeature[];
    public ptgCheckboxesOnlyInitial: { id: number; category: string; name: string; checked: boolean; }[] = [];
    public ptgCheckboxesShow: { id: number; category: string; name: string; checked: boolean; }[] = [];
    public organisationCheckboxesOnlyInitial: { id: number; category: string; name: string; checked: boolean; }[] = [];
    public organisationCheckboxesShow: { id: number; category: string; name: string; checked: boolean; }[] = [];
    public certificationCheckboxesShow: { id: number; category: string; name: string; checked: boolean; };
    public _commonFeatureCheckboxes: { id: number; category: string; name: string; checked: boolean; }[] = [];
    public searchText: string = '';
    public showProductCategoryBoxes: boolean = false;
    public showCertificationTypeBoxes: boolean = false;
    public showOrganisationBoxes: boolean = false;
    public showPtgBoxes: boolean = false;
    public showCommonFeatureBoxes: boolean = false;
    private activeOrgaType: OrganisationType;
    private orgaCertificationFromFilter: FilterOrganisationCertification[];
    private orgaProductsFromFilter: FilterOrganisationProduct[];
    public productCategoryCheckboxItems: { name: string; checked: boolean; value: ProductCategory; }[] = [
        { name: 'Software', checked: false, value: ProductCategory.Software },
        { name: 'Datenbanken', checked: false, value: ProductCategory.database },
        { name: 'Fachpublikation', checked: false, value: ProductCategory.SpecPub }
    ];
    // Stellt die Filtermoeglichkeiten nach Bewertungen da
    public productRatingCheckboxItem: { rating: string; checked: boolean; value: CheckBoxCategorie; }[] = [
        { rating: '5', checked: false, value: CheckBoxCategorie.RATING },
        { rating: '4', checked: false, value: CheckBoxCategorie.RATING },
        { rating: '3', checked: false, value: CheckBoxCategorie.RATING },
        { rating: '2', checked: false, value: CheckBoxCategorie.RATING },
        { rating: '1', checked: false, value: CheckBoxCategorie.RATING },
        { rating: 'Keine Bewertung', checked: false, value: null }
    ];

    public certProvidersCheckbox = { value: 'Zertifizierungsanbieter', checked: false };
    public certificationCategoryCheckboxItems: { name: string; checked: boolean; value: CertificationTypes; }[] = [
        {
            name: 'Merkmal-Zertifizierungen',
            checked: false,
            value: CertificationTypes.ATTRIBUTE_CERT
        },
        {
            name: 'Produkttyp-Zertifizierungen',
            checked: false,
            value: CertificationTypes.PTG_CERT
        }
    ];
    /**
     * checkbox values for subcategories for the marketplace filter
     */
    public certificationSubCategoriesCheckBoxItems: { name: string; checked: boolean; value: CertificationTypes; }[] = [
        {
            name: 'Alle',
            checked: false,
            value: null
        }
    ];
    certification: CertificationInterface;
    /**
     * checkbox values for subcategories for the marketplace filter
     */
    public applicationSubCategoriesCheckBoxItems: { name: string; checked: boolean; checkBoxCategory: CheckBoxCategorie; }[] = [
        {
            name: 'Alle',
            checked: false,
            checkBoxCategory: CheckBoxCategorie.APP_PRODUCTS
        }
    ];
    public doNothing() { }

    private emitActiveFilters() {
        this.activeFiltersChange.emit(this.marketPlaceFilterService.filter);
    }

    constructor(
        private marketPlaceFilterService: MarketplaceFilterService,
        private marketPlaceService: MarketplaceService,
        private certificationService: CertificationService,
        private trackingService: TrackingService,
        private cd: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    get categoryCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.PRODUCT_CATEGORY];
    }

    get ptgCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.PTG];
    }

    get organisationCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.ORGANISATION];
    }

    get attributeCertificationOrganisationCheckBoxes() {
        return this._checkBoxes[
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
        ];
    }

    get ptgCertificationOrganisationCheckBoxes() {
        return this._checkBoxes[
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
        ];
    }

    get toolchainCertificationOrganisationCheckBoxes() {
        return this._checkBoxes[
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
        ];
    }

    get commonFeatureCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.COMMON_FEATURE_ENTRY];
    }

    get certificationCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.CERTIFICATION];
    }

    get attr_certificationCheckboxes() {
        return this._checkBoxes[CheckBoxCategorie.ATTR_CERTIFICATION];
    }

    get toolChain_certificationCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.TOOLCHAIN_CERTIFICATION];
    }

    get ptg_certificationChecbkBoxes() {
        return this._checkBoxes[CheckBoxCategorie.PTG_CERTIFICATION];
    }

    get productCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.PRODUCTS];
    }

    get appProductCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.APP_PRODUCTS];
    }

    get serviceProductCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.SERVICE_PRODUCTS];
    }

    get contentProductCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.CONTENT_PRODUCTS];
    }

    get productOrganisationApplicationCheckBoxes() {
        return this._checkBoxes[
            CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
        ];
    }

    get productOrganisationServiceCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE];
    }

    get productOrganisationContentCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB];
    }

    get certificationOrganisationCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.CERTIFICATION_ORGANISATION];
    }
    get ratingCheckBoxes() {
        return this._checkBoxes[CheckBoxCategorie.RATING];
    }

    getProductCategoryName(id: string | number): string | undefined {
        return this.productCategoryCheckboxItems.find(i => i.value === id)?.name;
    }

    getCertificationName(id: string | number): string | undefined {
        return this._checkBoxes[CheckBoxCategorie.CERTIFICATION]?.find(i => i.id === id)?.label;
    }

    getAttributeName(id: string | number): string | undefined {
        return this._checkBoxes[CheckBoxCategorie.ATTRIBUTE]?.find(i => i.id === id)?.label;
    }

    getOrganisationName(id: string | number): string | undefined {
        return this._checkBoxes[CheckBoxCategorie.ORGANISATION]?.find(i => i.id === id)?.label;
    }

    getPtgName(id: string | number): string | undefined {
        return this._checkBoxes[CheckBoxCategorie.PTG]?.find(i => i.id === id)?.label;
    }

    removeFilterByChip(chip: { label: string, id: number | string, category: string }) {
        switch (chip.category) {
            case 'certification':
                const cert = this._checkBoxes[CheckBoxCategorie.CERTIFICATION]?.find(i => i.id === chip.id);
                if (cert) {
                    cert.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(cert.id, cert.categorie);
                }
                break;
            case 'attribute':
                const attr = this._checkBoxes[CheckBoxCategorie.ATTRIBUTE]?.find(i => i.id === chip.id);
                if (attr) {
                    attr.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(attr.id, attr.categorie);
                }
                break;
            case 'ptg':
                const ptg = this._checkBoxes[CheckBoxCategorie.PTG]?.find(i => i.id === chip.id);
                if (ptg) {
                    ptg.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(ptg.id, ptg.categorie);
                }
                break;
            case 'commonfeature':
                let entryFound = false;
                for (const featureGroup of this.commonFeatures) {
                    const entry = featureGroup.entries?.find(e => e.id === chip.id);
                    if (entry) {
                        entry.isChecked = false;
                        this.marketPlaceFilterService.removeFilter(entry.id, CheckBoxCategorie.COMMON_FEATURE_ENTRY);

                        // TODO: this is a workaround for common feature "Zielgruppen -> Fachplaner" sub entries.
                        // This logic should be handled in backend-service 
                        if (entry.id === this.fachPlanerId) {
                            this.fachPlanerEntries.forEach(x => {
                                x.isChecked = false;
                                this.marketPlaceFilterService.removeFilter(x.id, CheckBoxCategorie.COMMON_FEATURE_ENTRY);
                            });
                        }
                        entryFound = true;

                        break;
                    }
                }

                // TODO: this is a workaround for common feature "Zielgruppen -> Fachplaner" sub entries.
                // This logic should be handled in backend-service 
                if (!entryFound) {
                    const fachPlanerEntry = this.fachPlanerEntries?.find(e => e.id === chip.id);
                    if (fachPlanerEntry) {
                        fachPlanerEntry.isChecked = false;
                        this.marketPlaceFilterService.removeFilter(fachPlanerEntry.id, CheckBoxCategorie.COMMON_FEATURE_ENTRY);
                    }
                }

                break;
            case 'organisation':
                const org = this._checkBoxes[CheckBoxCategorie.ORGANISATION]?.find(i => i.id === chip.id);

                if (org) {
                    org.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(org.id, org.categorie);
                }
                break;
            case 'rating':
                const ratingItem = this.productRatingCheckboxItem.find(item => {
                    const idx = item.value ? item.rating : '0';
                    return Number(idx) === chip.id;
                });

                if (ratingItem) {
                    ratingItem.checked = false;

                    this.marketPlaceFilterService.removeFilter(
                        Number(chip.id),
                        CheckBoxCategorie.RATING
                    );
                }
                break;
        }
        this.emitActiveFilters();
    }

    public _checkBoxes: { [category: string]: MarketplaceCheckbox[] } = {
        PTG: [],
        PTG_ATTRIBUTE: [],
        ATTRIBUTE: [],
        ORGANISATION: [],
        CERTIFICATION_ORGANISATION_ATTRIBUTE: [],
        CERTIFICATION_ORGANISATION_PTG: [],
        CERTIFICATION_ORGANISATION_TOOLCHAIN: [],
        PRODUCT_ORGANISATION_SOFTWARE: [],
        PRODUCT_ORGANISATION_DATABASE: [],
        PRODUCT_ORGANISATION_SPEC_PUB: [],
        CERTIFICATION_ORGANISATION: [],
        COMMON_FEATURE: [],
        //
        CERTIFICATION: [],
        ATTR_CERTIFICATION: [],
        TOOLCHAIN_CERTIFICATION: [],
        PTG_CERTIFICATION: [],
        // monday 4.01
        PRODUCTS: [],
        APP_PRODUCTS: [],
        SERVICE_PRODUCTS: [],
        CONTENT_PRODUCTS: [],
        //
        RATING: []
    };

    /**
     * gibt eine Liste mit allen ausgewählten Produktkategorien wieder
     */
    private getCheckedProductCategories(): ProductCategory[] {
        let checkedCategories: ProductCategory[] = [];
        this.productCategoryCheckboxItems.forEach((checkbox) => {
            if (checkbox.checked) {
                checkedCategories.push(checkbox.value);
            }
        });
        return checkedCategories;
    }

    /**
     * gibt eine Liste mit allen ausgewählten Zertifikatstypen wieder
     */
    private getCheckedCertificationTypes(): CertificationTypes[] {
        let checkedCertTypes: CertificationTypes[] = [];
        this.certificationCategoryCheckboxItems.forEach((checkbox) => {
            if (checkbox.checked) {
                checkedCertTypes.push(checkbox.value);
            }
        });
        return checkedCertTypes;
    }

    /**
     * Generates and adds a Checkbox to the specific category of _checkBoxes if the Category does not yet exist
     *
     * @param id
     * @param label
     * @param category
     * @param isVisible
     * @param isCheck
     */
    public addCheckBox(
        id: number,
        label: string,
        category: CheckBoxCategorie,
        ptgId: number,
        ptgOptional: boolean,
        isVisible: boolean,
        isCheck: boolean
    ) {
        // select category

        var boxes = this._checkBoxes[category];
        // if boxes dont have the box with id
        if (!boxes.map((x) => { return x.id; }).includes(id)) {
            // add the new box
            let newBox = new MarketplaceCheckbox(
                id,
                category,
                label,
                ptgId,
                ptgOptional,
                isCheck,
                isVisible
            );
            if (boxes.length == 0) {
                boxes.push(newBox);
                return;
            }

            let i = 0;
            while (
                boxes.length != i &&
                boxes[i].label.localeCompare(label) < 1
            ) {
                i++;
            }
            boxes.splice(i, 0, newBox);
        }
    }

    /**
     * Sets isChecked for the given checkbox or boxes to true.
     *
     * @param id Id or array of Ids to identifiy checkbox by
     * @param category type of checkbox
     * @returns true if the checkbox or all checkboxes exists, else false
     */
    public setChecked(
        id: number | number[],
        category: CheckBoxCategorie
    ): boolean {
        if (!id) {
            return false;
        }
        // typeguard for array
        if (typeof id === 'number') {
            // single id function
            //--------------------------------------------------
            var boxes = this._checkBoxes[category]; // get matching checkboxes
            var index = boxes.findIndex((x) => x.id == id);
            if (index > 0) {
                // it it exists set it checked
                boxes[index].isChecked = true;

                return true;
            }
            return false;
            //--------------------------------------------------
        }
        if (id.length >= 1) {
            // recursive calling of the single number function
            // map basically becomes a foreach here
            return id
                .map((x) => this.setChecked(x, category))
                .reduce((x, y) => x && y);
        }
    }

    /**
     * Queries the Backend for all active attributes, orgnisations, PTgs and Common Features
     * to generate the initial checkboxes from.
     * Distinguishes between product screen state and certification screenstate to send the correct request
     * @param params The query parameters from the url: needed for checkbox initialization
     */
    initialiseCheckboxes(params: Params): void {
        this.marketPlaceService
            .getOfActiveEntities()
            .subscribe((filterData: FilterCheckboxDtoInterface) => {
                const mpFilter = this.marketPlaceFilterService.filter;

                this.initialiseAttributeCheckBoxes(
                    filterData.attributes,
                    mpFilter
                );
                this.initialiseCertificationCheckBoxes(
                    filterData.certifications,
                    mpFilter
                );
                this.initialiseProductCheckboxesByCategory(filterData.products);

                this.orgaCertificationFromFilter =
                    filterData.organisationCertifications;
                this.orgaProductsFromFilter = filterData.organisationProducts;

                this.initializeOrganisationCheckBoxes();
                Object.keys(filterData.ptgs).forEach((id) => this.ptgCategory[id] = filterData.ptgs[id].category);
                this.initialisePtgCheckboxes(filterData.ptgs, mpFilter);
                let targetGroupsIndex = -1;
                for (let commonFeature of filterData.commonFeatures) {
                    ++targetGroupsIndex;
                    if (commonFeature.name === "Zielgruppen") {
                        for (let entry of commonFeature.entries) {
                            if (entry?.pureName?.includes(";")) {
                                entry.isChecked = false;
                                this.fachPlanerEntries.push(entry);
                            }
                        }
                        break;
                    }
                }
                let targetGroups = filterData.commonFeatures[targetGroupsIndex].entries.filter((entry) => !entry.pureName.includes(";"));
                filterData.commonFeatures[targetGroupsIndex].entries = targetGroups;
                this.commonFeatures = filterData.commonFeatures;

                //Set checked filter boxes from urls query params, the filter init happens in marketplace-filter service updateFromService
                this.setCheckedBoxesFromQueryParams(params);
                this.emitActiveFilters();
            });
    }

    private initialiseAttributeCheckBoxes(
        attributeMap: Map<number, string>,
        mpFilter: MarketplaceFilterInterface
    ) {
        Object.keys(attributeMap).forEach((id) => {
            this.addCheckBox(
                Number(id),
                attributeMap[id],
                CheckBoxCategorie.ATTRIBUTE,
                undefined,
                undefined,
                true,
                mpFilter.attributeIds.includes(Number(id))
            );
        });
    }

    private initialiseCertificationCheckBoxes(
        certificationMap: Map<number, string>,
        mpFilter: MarketplaceFilterInterface
    ) {
        Object.keys(certificationMap).forEach((certification: string) => {
            this.addCheckBox(
                Number(certification),
                certificationMap[certification],
                CheckBoxCategorie.CERTIFICATION,
                undefined,
                undefined,
                true,
                mpFilter.certificationIds.includes(Number(certification))
            );
        });
    }

    private initialiseProductCheckboxesByCategory(
        products: FilterProductCategory[]
    ) {
        for (let product of products) {
            if (product.category == ProductCategory.Software) {
                this.addCheckBox(
                    product.id,
                    product.name,
                    CheckBoxCategorie.APP_PRODUCTS,
                    undefined,
                    undefined,
                    false,
                    false
                );
            }
            if (product.category == ProductCategory.SpecPub) {
                this.addCheckBox(
                    product.id,
                    product.name,
                    CheckBoxCategorie.CONTENT_PRODUCTS,
                    undefined,
                    undefined,
                    false,
                    false
                );
            }
            if (product.category == ProductCategory.database) {
                this.addCheckBox(
                    product.id,
                    product.name,
                    CheckBoxCategorie.SERVICE_PRODUCTS,
                    undefined,
                    undefined,
                    false,
                    false
                );
            }
        }
    }

    private initialisePtgCheckboxes(ptgMap: Map<number, string>, mpFilter: MarketplaceFilterInterface) {
        Object.keys(ptgMap).forEach((id) => {
            this.addCheckBox(
                Number(id),
                ptgMap[id].name,
                CheckBoxCategorie.PTG,
                undefined,
                undefined,
                true,
                mpFilter.ptgIds.includes(Number(id))
            );
        });
    }

    /**
     * initilialisert die CheckBoxen der Organisation neu abhängig vom MarketScreenState
     */
    private initializeOrganisationCheckBoxes() {
        switch (this.marketScreenState) {
            case DataType.PRODUCT:
                this.initialiseOrganisationBoxesFromArray(
                    this.orgaProductsFromFilter,
                    CheckBoxCategorie.ORGANISATION
                );
                this.minimiseAnbieter = false;
                break;
            case DataType.CERTIFICATION:
                this.initialiseOrganisationBoxesFromArray(
                    this.orgaCertificationFromFilter,
                    CheckBoxCategorie.ORGANISATION
                );
                this.minimiseAnbieter = true;
                break;
            case DataType.ORGANISATION:
                //Organisation screenstate: both filter returns (organisationProducts & organisationCertifications) are needed
                //For each product provider: Initialise checkbox by category
                this.initialiseProductOrganisationBoxesByCategoryFromArray(
                    this.orgaProductsFromFilter
                );
                //For each certification provider: Initialise checkbox by type
                this.initialiseCertificationOrganisationBoxesByTypeFromArray(
                    this.orgaCertificationFromFilter
                );
                this.checkCertOrg();
                break;
        }
    }

    private initialiseOrganisationBoxesFromArray(
        boxInfoArray: any[],
        category: CheckBoxCategorie
    ) {
        this.clearCheckboxByCategory(category);
        let organisationBoxesInfo: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        boxInfoArray.forEach((organisation) => {
            let organisationBoxInfo = {
                organisationName: organisation.name,
                organisationId: organisation.id
            };
            organisationBoxesInfo.push(organisationBoxInfo);
        });
        this.addCheckBoxForAllOrgaKeys(organisationBoxesInfo, category);
    }

    private initialiseProductOrganisationBoxesByCategoryFromArray(
        boxInfoArray: FilterOrganisationProduct[]
    ) {
        this.clearCheckboxByCategory(
            CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
        );
        this.clearCheckboxByCategory(
            CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE
        );
        this.clearCheckboxByCategory(
            CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB
        );
        let productOrgSoftware: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        let productOrgDatabase: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        let productOrgSpecPub: {
            organisationName: string;
            organisationId: number;
        }[] = [];

        boxInfoArray.forEach((organisation) => {
            let organisationBoxInfo = {
                organisationName: organisation.name,
                organisationId: organisation.id
            };
            if (organisation.hasActiveSoftwareProduct)
                productOrgSoftware.push(organisationBoxInfo);
            if (organisation.hasActiveDatabaseProduct)
                productOrgDatabase.push(organisationBoxInfo);
            if (organisation.hasActiveSpecPubProduct)
                productOrgSpecPub.push(organisationBoxInfo);
        });
        this.addCheckBoxForAllOrgaKeys(
            productOrgSoftware,
            CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
        );
        this.addCheckBoxForAllOrgaKeys(
            productOrgDatabase,
            CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE
        );
        this.addCheckBoxForAllOrgaKeys(
            productOrgSpecPub,
            CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB
        );
    }

    private initialiseCertificationOrganisationBoxesByTypeFromArray(
        boxInfoArray: FilterOrganisationCertification[]
    ) {
        this.clearCheckboxByCategory(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
        );
        this.clearCheckboxByCategory(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
        );
        this.clearCheckboxByCategory(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
        );
        let certificationOrganisationsAttribute: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        let certificationOrganisationsPtg: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        let certificationOrganisationsToolchain: {
            organisationName: string;
            organisationId: number;
        }[] = [];
        boxInfoArray.forEach((organisation) => {
            let organisationBoxInfo = {
                organisationName: organisation.name,
                organisationId: organisation.id
            };
            if (organisation.hasActiveAttributeCertification)
                certificationOrganisationsAttribute.push(organisationBoxInfo);
            if (organisation.hasActivePtgCertification)
                certificationOrganisationsPtg.push(organisationBoxInfo);
            if (organisation.hasActiveToolchainCertification)
                certificationOrganisationsToolchain.push(organisationBoxInfo);
        });
        this.addCheckBoxForAllOrgaKeys(
            certificationOrganisationsAttribute,
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
        );
        this.addCheckBoxForAllOrgaKeys(
            certificationOrganisationsPtg,
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
        );
        this.addCheckBoxForAllOrgaKeys(
            certificationOrganisationsToolchain,
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
        );
    }

    private addCheckBoxForAllOrgaKeys(
        organisationBoxesInfo: {
            organisationName: string;
            organisationId: number;
        }[],
        checkBoxCategory: CheckBoxCategorie
    ) {
        organisationBoxesInfo.forEach((organisationBox) => {
            this.addCheckBox(
                organisationBox.organisationId,
                organisationBox.organisationName,
                checkBoxCategory,
                undefined,
                undefined,
                true,
                this.marketPlaceFilterService.filter.organisationIds.includes(
                    organisationBox.organisationId
                )
            );
        });
    }

    /**
     * This method only sets the checked boxes for all filters that are set within the url query parameters, it does not affect the filter request
     * that is send to the backend. The filter is initialised form the query params in the marketplace-filter service
     * @param params Query Parameters from URL: These directly reflect all filter options
     */
    private setCheckedBoxesFromQueryParams(params: Params) {
        //productCategory checkboxes (Produktkategorie in Marketscreenstate Product | Produktanbieter in Marketscreenstate organisation)

        for (let productCategoryCheckBoxItem of this.productCategoryCheckboxItems) {
            if (productCategoryCheckBoxItem.value == params['category']) {
                productCategoryCheckBoxItem.checked = true;
                //

                if (this.marketScreenState === DataType.PRODUCT) {
                    this._receiveCheckedValueProductState();
                }
                if (this.marketScreenState === DataType.ORGANISATION) {
                    this.applicationSubCategoriesCheckBoxItems[0].checked = true;
                    this._receiveCheckedValueProductCertificationType(
                        OrganisationType.PRODUCT_PROVIDER,
                        this.productCategoryCheckboxItems.findIndex(i => i.value == params['category']),
                        params['category'],
                        true
                    );
                }
            }
        } // 2. hier setzen wir die boxen auf true aus der url
        let arr = params['certificationType'];

        for (let certificationCategoryCheckboxItem of this
            .certificationCategoryCheckboxItems) {
            if (
                arr != undefined &&
                arr.includes(certificationCategoryCheckboxItem.value.toString())
            ) {
                certificationCategoryCheckboxItem.checked = true;

                if (
                    params['certifiId'] ||
                    this.marketScreenState === DataType.PRODUCT
                ) {
                    this._receiveCheckedValueCertificationState();
                }

                if (params['orgId']) {
                    this.certificationCategoryCheckboxItems[0].checked = true;
                }
            }
        }
        // Workaround for hard coded orgId in url
        if (this.marketScreenState === DataType.ORGANISATION) {
            if (!params['category'] && params['orgId'] && !params['organisationId']) {
                this.certProvidersCheckbox.checked = true;
            }
        }

        if (params['search']) {
            this.searchText = params['search'];
            this.filterBySearchText();
        }

        this.sortCertificationCheckBoxCategories();
        this.setSubCheckBox(
            CheckBoxCategorie.APP_PRODUCTS,
            'appSubPro',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.SERVICE_PRODUCTS,
            'appSubPro',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.CONTENT_PRODUCTS,
            'appSubPro',
            params
        );
        this.setSubCheckBox(CheckBoxCategorie.ORGANISATION, 'orgId', params);
        this.setSubCheckBoxCerti(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE,
            'orgId',
            params
        );
        this.setSubCheckBoxCerti(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG,
            'orgId',
            params
        );
        this.setSubCheckBoxCerti(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN,
            'orgId',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE,
            'orgId',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE,
            'orgId',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB,
            'orgId',
            params
        );
        this.setSubCheckBox(
            CheckBoxCategorie.CERTIFICATION_ORGANISATION,
            'orgId',
            params
        );
        this.setSubCheckBox(CheckBoxCategorie.PTG, 'ptgId', params);

        this.setRatingCheckBox(CheckBoxCategorie.RATING, 'rating', params);

        this.setSubCheckBoxCerti(
            CheckBoxCategorie.CERTIFICATION,
            'certifiId',
            params
        );

        if (params['attr']) this.setCommunFeatureCheckBox('attr', params);
        this.cd.detectChanges();
    }

    private isIdinParam(id: string, listOfids: string[]): boolean {
        let idIsThere = false;

        for (let idx = 0; idx < listOfids.length && !idIsThere; idx++) {
            if (listOfids[idx] === id) {
                idIsThere = true;
            }
        }

        return idIsThere;
    }

    private setCommunFeatureCheckBox(paramKey: string, params: Params) {
        let urlattr = params[paramKey];

        for (let commonFeature of this.commonFeatures) {
            for (let entry of commonFeature.entries) {
                let idOfEntry = entry.id + '';
                let correctId = Array.isArray(urlattr)
                    ? this.isIdinParam(idOfEntry, urlattr)
                    : idOfEntry === urlattr;

                if (urlattr && urlattr.includes(idOfEntry) && correctId) {
                    entry.isChecked = true;
                    this.marketPlaceFilterService.addFilter(entry.id, CheckBoxCategorie.COMMON_FEATURE_ENTRY);
                }
            }
        }
    }

    private setRatingCheckBox(
        categorie: CheckBoxCategorie,
        paramKey: string,
        params: Params
    ): void {
        let urlAppSubPro = params[paramKey];

        for (let productAppSubCheckBoxItem of this.productRatingCheckboxItem) {
            let idOfProduct = productAppSubCheckBoxItem.rating;

            if (!productAppSubCheckBoxItem.value)
                idOfProduct =
                    productAppSubCheckBoxItem.rating === 'Alle' ? '6' : '0';
            let correctId = Array.isArray(urlAppSubPro)
                ? this.isIdinParam(idOfProduct, urlAppSubPro)
                : idOfProduct === urlAppSubPro;

            if (urlAppSubPro && urlAppSubPro.includes(idOfProduct) && correctId) {
                productAppSubCheckBoxItem.checked = true;
                this.marketPlaceFilterService.addFilter(Number(idOfProduct), CheckBoxCategorie.RATING);
            }
        }
    }

    private setSubCheckBox(
        categorie: CheckBoxCategorie,
        paramKey: string,
        params: Params
    ): void {
        let urlAppSubPro = params[paramKey];

        for (let productAppSubCheckBoxItem of this._checkBoxes[categorie]) {
            let idOfProduct = productAppSubCheckBoxItem.id + '';
            let correctId = Array.isArray(urlAppSubPro)
                ? this.isIdinParam(idOfProduct, urlAppSubPro)
                : idOfProduct === urlAppSubPro;

            if (urlAppSubPro && urlAppSubPro.includes(idOfProduct) && correctId) {
                productAppSubCheckBoxItem.isChecked = true;
                this.marketPlaceFilterService.addFilter(productAppSubCheckBoxItem.id, productAppSubCheckBoxItem.categorie);
            }
        }
    }

    private setSubCheckBoxCerti(
        categorie: CheckBoxCategorie,
        paramKey: string,
        params: Params
    ): void {
        let counterAll = 0;
        let urlAppSubPro = params[paramKey];

        this._checkBoxes[categorie].forEach(
            (categoryBox: MarketplaceCheckbox) => {
                let idOfProduct = categoryBox.id + '';
                let correctId = Array.isArray(urlAppSubPro)
                    ? this.isIdinParam(idOfProduct, urlAppSubPro)
                    : idOfProduct === urlAppSubPro;
                if (urlAppSubPro && urlAppSubPro.includes(idOfProduct) && correctId) {
                    counterAll++;
                    categoryBox.isChecked = true;
                    this.marketPlaceFilterService.addFilter(categoryBox.id, categoryBox.categorie);
                }
            }
        );
        if (counterAll == 0) {
            this.certificationSubCategoriesCheckBoxItems[0].checked = true;
        }
    }

    /**
     * Löscht die Filter sowie alle Checkboxen der angegebenen Kategorie
     * @param checkBoxCategorie
     */
    private clearCheckboxByCategory(
        checkBoxCategorie: CheckBoxCategorie
    ): void {
        this._checkBoxes[checkBoxCategorie].forEach((element) => {
            this.marketPlaceFilterService.removeFilter(
                element.id,
                element.categorie
            );
        });
        this._checkBoxes[checkBoxCategorie] = [];
    }

    updateFromService() {
        const mpFilter = this.marketPlaceFilterService.filter;
        mpFilter.attributeIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.ATTRIBUTE, true);
        });
        mpFilter.organisationIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.ORGANISATION, true);
        });
        mpFilter.ptgIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.PTG, true);
        });
        mpFilter.commonFeatureIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.COMMON_FEATURE_ENTRY, true);
        });
        mpFilter.certificationIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.CERTIFICATION, true);
        });
        mpFilter.productIds.forEach((id) => {
            this.setCheckBox(id, CheckBoxCategorie.PRODUCTS, true);
        });

        this.cd.detectChanges();
    }

    setCheckBox(id: number, categorie: CheckBoxCategorie, setChecked: boolean) {
        this._checkBoxes[categorie].forEach((checkBox: MarketplaceCheckbox) => {
            if (checkBox.isChecked && checkBox.isVisible) {
                checkBox.isChecked = setChecked;
                this.marketPlaceFilterService.addFilter(checkBox.id, checkBox.categorie);
            }
        });
    }

    /**
     * This is the function that is bound to the Checkbox clicked method in the gui.
     * Adds respectively Removes the filter condition in the filter service depending
     * if the fireing checkbox was set "checked" or "unchecked"
     *
     * @param box the Checkbox handed from the gui
     * @param event the MathCheckbox event from the gui
     */
    _receiveCheckedValue(box: MarketplaceCheckbox, event: MatCheckboxChange) {
        box.isChecked = event.checked;

        // this links the MatCheckbox state to the Checkbox Domain Object
        if (box.isChecked) {
            //this.marketPlaceFilterService.setProductCategoryFilter([]);
            this.marketPlaceFilterService.addFilter(box.id, box.categorie);
        } else {
            this.marketPlaceFilterService.removeFilter(box.id, box.categorie);
        }
        this.emitActiveFilters();
    }

    /**
  Specific for ratings
   * This is the function that is bound to the Checkbox clicked method in the gui.
   * Adds respectively Removes the filter condition in the filter service depending
   * if the fireing checkbox was set "checked" or "unchecked"
   *
   * @param box the Checkbox handed from the gui
   * @param event the MathCheckbox event from the gui
   */
    _receiveCheckedValueRating(rating: string, event: MatCheckboxChange) {
        this.productRatingCheckboxItem.forEach((checkbox) => {
            if (!checkbox.value) {
                checkbox.checked = false;
                let idx = checkbox.rating === 'Alle' ? '6' : '0';
                this.marketPlaceFilterService.removeFilter(
                    Number(idx),
                    CheckBoxCategorie.RATING
                );
            }
        });
        // this links the MatCheckbox state to the Checkbox Domain Object
        if (event.checked) {
            this.marketPlaceFilterService.addFilter(Number(rating), CheckBoxCategorie.RATING);
        } else {
            this.marketPlaceFilterService.removeFilter(Number(rating), CheckBoxCategorie.RATING);
        }
        this.emitActiveFilters();
    }

    /**
  Specific for ratings
   * This is the function that is bound to the Checkbox clicked method in the gui.
   * Adds respectively Removes the filter condition in the filter service depending
   * if the fireing checkbox was set "checked" or "unchecked"
   *
   * @param box the Checkbox handed from the gui
   * @param event the MathCheckbox event from the gui
   */
    _receiveCheckedValueRatingAllWithout(
        rating: string,
        event: MatCheckboxChange
    ) {
        this.productRatingCheckboxItem.forEach((checkbox) => {
            if (checkbox.rating !== rating) {
                checkbox.checked = false;
                let idx = checkbox.rating;

                if (!checkbox.value)
                    idx = checkbox.rating === 'Alle' ? '6' : '0';

                this.marketPlaceFilterService.removeFilter(
                    Number(idx),
                    CheckBoxCategorie.RATING
                );
            }
        });

        rating = rating === 'Alle' ? '6' : '0';
        // this links the MatCheckbox state to the Checkbox Domain Object
        if (event.checked) {
            this.marketPlaceFilterService.addFilter(Number(rating), CheckBoxCategorie.RATING);
        } else {
            this.marketPlaceFilterService.removeFilter(Number(rating), CheckBoxCategorie.RATING);
        }
        this.emitActiveFilters();
    }

    checkedCommonFeatureEntryBox(commonFeatureEntry: FilterCommonFeatureEntry, event: MatCheckboxChange) {
        commonFeatureEntry.isChecked = event.checked;
        let commonFeatureBox: MarketplaceCheckbox = {
            id: commonFeatureEntry.id,
            categorie: CheckBoxCategorie.COMMON_FEATURE_ENTRY,
            label: commonFeatureEntry.name,
            ptgId: undefined,
            isChecked: commonFeatureEntry.isChecked,
            isVisible: true,
            ptgOptional: undefined
        };
        switch (commonFeatureEntry.linkingMethod.toString()) {
            case 'XOR':
                this.commonFeatures.forEach((x) => {
                    x.entries.forEach((y) => {
                        if (commonFeatureEntry.id != y.id && y.linkingMethod?.toString() == 'XOR') {
                            y.isChecked = false;
                            this.marketPlaceFilterService.removeFilter(y.id, commonFeatureBox.categorie);
                        }
                    });
                });
                break;
        }
        if (commonFeatureBox.isChecked) {
            if (!this.marketPlaceFilterService.filter.commonFeatureIds.includes(commonFeatureBox.id))
                this.marketPlaceFilterService.addFilter(commonFeatureBox.id, commonFeatureBox.categorie);
        } else {
            this.marketPlaceFilterService.removeFilter(commonFeatureBox.id, commonFeatureBox.categorie);
            if (commonFeatureBox.id == this.fachPlanerId)
                this.fachPlanerEntries.forEach(x => {
                    x.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(x.id, commonFeatureBox.categorie);
                });
        }
        this.emitActiveFilters();
    }

    /**
     * Aufgerufen, wenn in der OrganisationsScreenState nur nach dem OrgaTyp geklickt wird
     */
    _receiveCheckedValueOrganisationType(): void {
        this.marketPlaceFilterService.setOrgaTypeFilter(this.activeOrgaType, [], []);
    }

    /**
     * Aufgerufen, wenn einer der Filtermöglichkeiten unter Produktkategorie oder Zertifizierungstyp angeklickt wurde abhängig vom MarketScreenState
     * @param organisationType Orgatyp, damit in der OrganisationState zwischen Produktanbietern und Zertifizierungsanbietern unterschieden werden kann
     * @param index, position der einzigen CheckBox die checked sein kann, alle anderen checkboxes werden false gesetzt
     */
    _receiveCheckedValueProductCertificationType(organisationType?: OrganisationType, index?: number, category?, checked?): void {
        this.activeOrgaType = organisationType;

        // limitiert die Boxauswahl auf maximal 1
        if (organisationType != OrganisationType.CERTIFICATION_PROVIDER) {
            this.limitCheckboxesToOne(organisationType, index);
        }
        if (this.marketScreenState === DataType.CERTIFICATION) {
            this._receiveCheckedValueCertificationState();
        } else if (this.marketScreenState === DataType.PRODUCT) {
            this._receiveCheckedValueProductState();
        } else if (this.marketScreenState === DataType.ORGANISATION) {
            if (category) {
                if (!checked) {
                    // categorys die noch angekreuzt sind
                    let arrCategory = [];
                    let notSelected = true;

                    for (let certificationOrganisationCategory of this.certificationCategoryCheckboxItems) {
                        notSelected = notSelected && !certificationOrganisationCategory.checked;
                        if (certificationOrganisationCategory.checked) {
                            arrCategory.push(certificationOrganisationCategory.value);
                        }
                    }

                    if (notSelected || organisationType === OrganisationType.PRODUCT_PROVIDER) {
                        this.resetFilters();
                    }

                    this.marketPlaceFilterService.setCertificationTypeFilter(arrCategory);
                    this.marketPlaceFilterService.setProductCategoryFilter([]);
                } else if (organisationType === OrganisationType.PRODUCT_PROVIDER) {
                    for (let certificationOrganisationCategory of this.certificationCategoryCheckboxItems) {
                        certificationOrganisationCategory.checked = false;
                    }
                    this.marketPlaceFilterService.setCertificationTypeFilter([]);
                    category = checked ? [category] : [];
                    this.marketPlaceFilterService.setProductCategoryFilter(category);
                } else {
                    for (let productOrganisationCategory of this.productCategoryCheckboxItems) {
                        productOrganisationCategory.checked = false;
                        //  this.resetAllSubCheckBoxFilter();
                    }
                    this.marketPlaceFilterService.setProductCategoryFilter([]);
                    this._receiveCheckedValueCertificationState();
                }
            }
        }
    }

    private _receiveCheckedValueCertificationState(): void {
        let certificationTypes = this.getCheckedCertificationTypes();
        this.marketPlaceFilterService.setCertificationTypeFilter(
            certificationTypes
        );
    }

    private _receiveCheckedValueProductState(): void {
        let productCategories = this.getCheckedProductCategories();
        let certificationTypes = this.getCheckedCertificationTypes();

        this.marketPlaceFilterService.setProductCategoryFilter(
            productCategories
        );
        this.marketPlaceFilterService.setCertificationTypeFilter(
            certificationTypes
        );
    }

    // limitiert Auswahl der Checkboxes auf 1
    private limitCheckboxesToOne(orgaType: OrganisationType, index: number): void {
        let selectedCheckboxes: {
            name: string;
            checked: boolean;
            value: ProductCategory;
        }[] = this.productCategoryCheckboxItems;

        let checkedBoxName = "none";
        if (orgaType == OrganisationType.PRODUCT_PROVIDER) {
            checkedBoxName = selectedCheckboxes[index].name
            this.certProvidersCheckbox.checked = false;
        }

        //set other boxes false
        selectedCheckboxes.forEach((box) => {
            if (box.name != checkedBoxName) {
                box.checked = false;
            }
        });
    }

    /**
     * Sortfunction used with the sort order button.
     * This is another 3 way merry-go-round property binding function.
     * Endpoint is orderByOrganisation in marketplace-productoverview.component.
     * #LEGACY
     *
     * @param sort some wierd string to number thingamajig which ends up a boolean anyway....
     */
    sortBy(sort: string) {
        var int = Math.abs(this.sortOptions.findIndex((y) => y.name === sort));
        switch (int) {
            case 0: {
                this.marketPlaceFilterService.orderByOrganisationSubject.next(
                    false
                );
                break;
            }
            case 1: {
                this.marketPlaceFilterService.orderByOrganisationSubject.next(
                    true
                );
                break;
            }
        }
    }

    setSortOption(sort: SortMethod): void {
        this.marketPlaceFilterService.sortingOptionSubject.next(sort);
        this.sortOrder = sort;
    }

    /**
     * Setzt alle Filter zurück
     */
    resetFilters(): void {
        for (var category in CheckBoxCategorie) {
            if (this._checkBoxes[category] && category != CheckBoxCategorie.PRODUCT_CATEGORY) {
                this.resetCategoryBoxes(category);
            }
        }
        this.showCertificationTypeBoxes = false;
        this.showOrganisationBoxes = false;
        this.showProductCategoryBoxes = false;
        this.showCommonFeatureBoxes = false;
        this.showPtgBoxes = false;
        this.marketPlaceFilterService.productFilter = [];
        if (this.marketScreenState != DataType.PRODUCT) { this.marketPlaceFilterService.productCategories = []; }
        this.marketPlaceFilterService.setOrgaTypeFilter(null, this.marketPlaceFilterService.productCategories, []);
        this.marketPlaceFilterService.commonFeatureEntriesFilter = [];
        this.marketPlaceFilterService.ratingFilter = [];
        this.emitActiveFilters();
    }

    removeFilter(filter: { label: string, id: number, category: string }) {
        this.emitActiveFilters();
    }

    private resetCategoryBoxes(category: CheckBoxCategorie | string): void {
        this._checkBoxes[category].forEach((checkBox: MarketplaceCheckbox) => {
            if (checkBox.isChecked) {
                checkBox.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    checkBox.id,
                    checkBox.categorie
                );
            }
        });
    }

    filterProductSearchText(): void {
        this.marketPlaceFilterService.receiveSearchText(this.searchText);
        this.trackingService.eventEmitter(
            'search',
            'filter',
            'product_search_term',
            this.searchText
        );
    }

    filterOrganisationSearchText(): void {
        this.marketPlaceFilterService.receiveSearchText(this.searchText);
        this.trackingService.eventEmitter(
            'search',
            'filter',
            'orga_search_term',
            this.searchText
        );
    }

    filterCertificationSearchText(): void {
        this.marketPlaceFilterService.receiveSearchText(this.searchText);
        this.trackingService.eventEmitter(
            'search',
            'filter',
            'certification_search_term',
            this.searchText
        );
    }

    filterToolchainSearchText(): void {
        this.marketPlaceFilterService.receiveSearchText(this.searchText);
        this.trackingService.eventEmitter(
            'search',
            'filter',
            'toolchain_search_term',
            this.searchText
        );
    }

    toggleCheckBoxByCategory(category: CheckBoxCategorie) {
        if (category === CheckBoxCategorie.ORGANISATION) {
            this.showOrganisationBoxes = !this.showOrganisationBoxes;
        } else if (category === CheckBoxCategorie.PTG) {
            this.showPtgBoxes = !this.showPtgBoxes;
        } else if (category === CheckBoxCategorie.COMMON_FEATURE_ENTRY) {
            this.showCommonFeatureBoxes = !this.showCommonFeatureBoxes;
        }

        this._checkBoxes[category].forEach((box) => {
            this.marketPlaceFilterService.removeFilter(box.id, box.categorie);
            box.isChecked = false;
        });
    }

    private resetCertificationAndProductBoxes(): void {
        this.resetCertificationBoxes();
        this.resetProductCategoryBoxes();
    }

    private resetCertificationBoxes(): void {
        this.certProvidersCheckbox.checked = false;
        this.certificationCategoryCheckboxItems.forEach(
            (checkbox) => (checkbox.checked = false)
        );
    }

    private resetCommonFeaturesBoxes(): void {
        this.commonFeatures?.forEach((x) => {
            x.entries.forEach((y) => {
                y.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    y.id,
                    CheckBoxCategorie.COMMON_FEATURE_ENTRY
                );
            });
        });

        // TODO: this is a workaround for common feature "Zielgruppen -> Fachplaner" sub entries.
        // This logic should be handled in backend-service 
        this.fachPlanerEntries?.forEach((entry) => {
            entry.isChecked = false;
            this.marketPlaceFilterService.removeFilter(
                entry.id,
                CheckBoxCategorie.COMMON_FEATURE_ENTRY
            );
        });
    }

    private resetProductCategoryBoxes(): void {
        this.productCategoryCheckboxItems.forEach((checkbox) => {
            checkbox.checked = false;
            this.resetAllSubCheckBoxFilter();
        });
    }

    private resetRatingCategoryBoxes(): void {
        this.productRatingCheckboxItem.forEach((checkbox) => {
            checkbox.checked = false;
            this.marketPlaceFilterService.removeFilter(
                Number(checkbox.rating),
                checkbox.value
            );
        });
    }

    /** storing all certifications in the CHECKBOXCATEGORIE.CERTIFICATION checkbox
     *   and then dividing them based on the certificationtype to different checkboxes
     */
    public sortCertificationCheckBoxCategories() {
        var totalNumberOfElements: number = 0;
        var certificationSubject: BehaviorSubject<
            CertificationOverviewInterface[]
        > = new BehaviorSubject([]);
        var currentRequest: Unsubscribable;
        var pageSize: number = 100;
        var breakLoop: number = Math.ceil(
            this._checkBoxes[CheckBoxCategorie.CERTIFICATION].length / pageSize
        );
        if (!this._checkBoxes[CheckBoxCategorie.ATTR_CERTIFICATION].length) {
            for (
                var pageIndex: number = 0;
                pageIndex < breakLoop;
                pageIndex++
            ) {
                currentRequest = this.certificationService
                    .getFilteredCertificationSlice(
                        pageIndex,
                        pageSize,
                        [],
                        [],
                        [],
                        [],
                        '',
                        SortMethod.ALPHABETICAL_DESC
                    )
                    .subscribe((certPage: any) => {
                        totalNumberOfElements =
                            certPage.totalNumberOfCertifications;
                        certPage.certificationSlice.forEach(
                            (certification: CertificationOverviewInterface) => {
                                this._checkBoxes[
                                    CheckBoxCategorie.CERTIFICATION
                                ].forEach((certBox: MarketplaceCheckbox) => {
                                    if (
                                        certBox.label ===
                                        certification.certificationName
                                    ) {
                                        switch (
                                        certification.certificationType
                                        ) {
                                            case 'ATTRIBUTE_CERT':
                                                if (
                                                    !this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .ATTR_CERTIFICATION
                                                    ].includes(certBox) &&
                                                    certification.productsCertified >
                                                    0
                                                )
                                                    this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .ATTR_CERTIFICATION
                                                    ].push(certBox);
                                                break;
                                            case 'TOOLCHAIN_CERT':
                                                if (
                                                    !this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .TOOLCHAIN_CERTIFICATION
                                                    ].includes(certBox) &&
                                                    certification.productsCertified >
                                                    0
                                                )
                                                    this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .TOOLCHAIN_CERTIFICATION
                                                    ].push(certBox);
                                                break;
                                            case 'PTG_CERT':
                                                if (
                                                    !this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .PTG_CERTIFICATION
                                                    ].includes(certBox) &&
                                                    certification.productsCertified >
                                                    0
                                                )
                                                    this._checkBoxes[
                                                        CheckBoxCategorie
                                                            .PTG_CERTIFICATION
                                                    ].push(certBox);
                                                break;
                                        }
                                    }
                                });
                            }
                        );
                        certificationSubject.next(certPage.certificationSlice);
                    });
            }
        }
    }

    /**
     *  handles the toggle behaviour of the subcheckboxes for product categories on the product marketplace page
     *  if "alle" is selected, every other element that is currently selected gets unselected and removed from the filter
     * @param category
     * @param isMainCheckBox
     */
    public toggleProductCheckBoxes(category: any, isMainCheckBox: boolean) {
        if (!isMainCheckBox) {
            if (!this.marketPlaceFilterService.productFilter.length)
                this.applicationSubCategoriesCheckBoxItems[0].checked = true;
            this._checkBoxes[category].forEach((box: MarketplaceCheckbox) => {
                if (box.isChecked) {
                    this.applicationSubCategoriesCheckBoxItems[0].checked = false;
                }
            });
        } else {
            this.marketPlaceFilterService.filterSpinner = true;
            this.applicationSubCategoriesCheckBoxItems[0].checked = true;
            this.resetAllSubCheckBoxFilter();
        }
        this.cd.detectChanges();
    }

    /**
     *  handles the toggle behavior of the subcheckboxes
     *  if "alle" is selected, every other element that is selected gets unselected and removed from the filter
     */
    public toggleCertificationSubCheckBoxes(
        category: CheckBoxCategorie,
        certType: CertificationTypes
    ) {
        if (!this.marketPlaceFilterService.certificationFilter.length)
            this.certificationSubCategoriesCheckBoxItems[0].checked = true;
        if (certType === null) {
            let isActive: boolean = true;
            this._checkBoxes[category].forEach(
                (categoryBox: MarketplaceCheckbox) => {
                    if (categoryBox.isChecked) {
                        isActive = false;
                    }
                }
            );
            this.certificationSubCategoriesCheckBoxItems[0].checked = isActive;
        } else {
            this.marketPlaceFilterService.filterSpinner = true;
            this.certificationSubCategoriesCheckBoxItems[0].checked = true;
            this.resetToggleCertificationBoxes(certType);
        }
        this.cd.detectChanges();
    }

    public resetToggleCertificationBoxes(certType: CertificationTypes) {
        switch (certType) {
            case CertificationTypes.ATTRIBUTE_CERT:
                this._checkBoxes[CheckBoxCategorie.ATTR_CERTIFICATION].forEach(
                    (box: MarketplaceCheckbox) => {
                        box.isChecked = false;
                        this.marketPlaceFilterService.removeFilter(
                            box.id,
                            box.categorie
                        );
                    }
                );
                break;
            case CertificationTypes.PTG_CERT:
                this._checkBoxes[CheckBoxCategorie.PTG_CERTIFICATION].forEach(
                    (box: MarketplaceCheckbox) => {
                        box.isChecked = false;
                        this.marketPlaceFilterService.removeFilter(
                            box.id,
                            box.categorie
                        );
                    }
                );
                break;
            case CertificationTypes.TOOLCHAIN_CERT:
                this._checkBoxes[
                    CheckBoxCategorie.TOOLCHAIN_CERTIFICATION
                ].forEach((box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                });
                break;
        }
    }

    public resetAllFilters() {
        this.marketPlaceFilterService.filterSpinner = true;
        this.resetFilters();
        this.resetCertificationAndProductBoxes();
        this.resetCommonFeaturesBoxes();
        this.marketPlaceFilterService.filter.organisationIds.length = 0;
        this.marketPlaceFilterService.setQueryParams();
        this.marketPlaceFilterService.resetSearchTextValue();
        this.resetRatingCategoryBoxes();
        this.searchText = '';
        this.resetAll.emit();
        this.cd.detectChanges();
    }

    /**
     * resetting all subcheckboxes when 'alle' is selected
     */
    private resetAllSubCheckBoxFilter() {
        if (this.marketScreenState == DataType.ORGANISATION) {
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });
        }

        if (this.marketPlaceFilterService.productFilter.length) {
            this._checkBoxes[CheckBoxCategorie.APP_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.SERVICE_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.CONTENT_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.PRODUCTS].forEach(
                (box: MarketplaceCheckbox) =>
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        CheckBoxCategorie.PRODUCTS
                    )
            );
        }
        if (this.marketPlaceFilterService.certificationFilter.length) {
            this._checkBoxes[CheckBoxCategorie.ATTR_CERTIFICATION].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                }
            );
            this._checkBoxes[CheckBoxCategorie.TOOLCHAIN_CERTIFICATION].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                }
            );
            this._checkBoxes[CheckBoxCategorie.PTG_CERTIFICATION].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                }
            );
            this._checkBoxes[CheckBoxCategorie.CERTIFICATION].forEach(
                (box: MarketplaceCheckbox) => {
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        CheckBoxCategorie.CERTIFICATION
                    );
                }
            );
        }
    }

    public resetAllSubCheckBoxWOCertFilter() {
        if (this.marketScreenState == DataType.ORGANISATION) {
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });

            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
            ].forEach((box: MarketplaceCheckbox) => {
                box.isChecked = false;
                this.marketPlaceFilterService.removeFilter(
                    box.id,
                    box.categorie
                );
            });
        }

        if (this.marketPlaceFilterService.productFilter.length) {
            this._checkBoxes[CheckBoxCategorie.APP_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.SERVICE_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.CONTENT_PRODUCTS].forEach(
                (box: MarketplaceCheckbox) => {
                    box.isChecked = false;
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        box.categorie
                    );
                }
            );
            this._checkBoxes[CheckBoxCategorie.PRODUCTS].forEach(
                (box: MarketplaceCheckbox) =>
                    this.marketPlaceFilterService.removeFilter(
                        box.id,
                        CheckBoxCategorie.PRODUCTS
                    )
            );
        }
    }

    public filterBySearchText(): void {
        switch (this.marketScreenState) {
            case this.dataTypeEnum.PRODUCT: {
                this.filterProductSearchText();
            }
            case this.dataTypeEnum.ORGANISATION: {
                this.filterOrganisationSearchText();
            }
            case this.dataTypeEnum.CERTIFICATION: {
                this.filterCertificationSearchText();
            }
            case this.dataTypeEnum.TOOLCHAIN: {
                this.filterToolchainSearchText();
            }
        }
    }

    private _autoComplete(value: string): string[] {
        const filterValue = value.toLowerCase();
        this.filterString = [];
        if (this.marketScreenState == 'PRODUCT') {
            this._checkBoxes[CheckBoxCategorie.APP_PRODUCTS].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
            this._checkBoxes[CheckBoxCategorie.SERVICE_PRODUCTS].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
            this._checkBoxes[CheckBoxCategorie.CONTENT_PRODUCTS].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
        } else if (this.marketScreenState == 'CERTIFICATION') {
            this._checkBoxes[CheckBoxCategorie.ATTR_CERTIFICATION].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
            this._checkBoxes[CheckBoxCategorie.TOOLCHAIN_CERTIFICATION].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
            this._checkBoxes[CheckBoxCategorie.PTG_CERTIFICATION].forEach(
                (element) => {
                    this.filterString.push(element.label);
                }
            );
        } else if (this.marketScreenState == 'ORGANISATION') {
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SOFTWARE
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_SPEC_PUB
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
            this._checkBoxes[
                CheckBoxCategorie.PRODUCT_ORGANISATION_DATABASE
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_ATTRIBUTE
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_PTG
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
            this._checkBoxes[
                CheckBoxCategorie.CERTIFICATION_ORGANISATION_TOOLCHAIN
            ].forEach((element) => {
                if (!this.filterString.includes(element.label)) {
                    this.filterString.push(element.label);
                }
            });
        }
        return this.filterString.filter(
            (option) => option.toLowerCase().indexOf(filterValue) === 0
        );
    }

    fillSearchAutoCompleteList(): string[] {
        this._checkBoxes[CheckBoxCategorie.APP_PRODUCTS].forEach((element) => {
            this.filterString.push(element.label);
        });

        return this.filterString;
    }

    ngOnChange(): void {
        this.emitActiveFilters();
    }

    ngOnInit(): void {
        this.filteredOptions = this.prodControl.valueChanges.pipe(
            startWith(''),
            debounceTime(200),
            tap(value => {
                this.searchText = value;
                this.filterBySearchText();
            }),
            map(value => this._autoComplete(value))
        );

        this.externalSearch$
            ?.pipe(debounceTime(200))
            .subscribe(value => {
                this.searchText = value;
                const filtered = this._autoComplete(value);
                this.filteredOptions = of(filtered);
                this.prodControl.setValue(value, { emitEvent: false });
                this.filterBySearchText();
            });

        this.marketPlaceFilterService.screenStateObservable.subscribe(
            (marketScreenState) => {
                this.marketScreenState = marketScreenState;
            }
        );

        this.marketPlaceFilterService.productCategoryStateObserval.subscribe(
            (productCategoryScreenState) => {
                this.productCategoryScreenState = productCategoryScreenState;
            }
        );
        //Takes the Query parameters from url; initialise all checkboxes and check the selected filter boxes from params
        //Take(1) is important: Only the first set of params is used for initialising and checking of the filter boxes
        //A permanent subscription will cause an infinite loop

        this.queryParamSubscription = this.route.queryParams
            .pipe(take(1))
            .subscribe((params) => {
                this.initialiseCheckboxes(params);
            });

        this.filterSubscription = this.marketPlaceFilterService
            .getToggleBooleanClearFilter()
            .subscribe((x) => {
                if (x) {
                    this.marketPlaceFilterService.resetFilters();
                    this.resetAllFilters();
                }
            });
        this.emitActiveFilters();
    }

    ngOnDestroy() {
        if (!this.router.url.includes('tab=')) {
            this.resetAllFilters();
        }

        if (this.filterSubscription) this.filterSubscription.unsubscribe();
    }

    featureAppliesToCurrentCategories(commonFeature: CommonFeatureInterface): boolean {
        if (this.marketPlaceFilterService.getProductCategoryFilter().length == 0) {
            return true;
        }

        return commonFeature.categories.some(category =>
            this.marketPlaceFilterService.getProductCategoryFilter().includes(category)
        );
    }

    checkBoxesAndToggleCert() {
        this.minimiseZert = !this.minimiseZert;
    }

    getCurrentRoute() {
        return this.router.url;
    }

    isPtgIncludedInCategory(ptg: MarketplaceCheckbox): boolean {
        return this.getCurrentRoute().includes(this.ptgCategory[ptg.id]) ||
            !this.getCurrentRoute().includes('category=');
    }

    checkCertOrg() {
        // if (this.marketScreenState === 'ORGANISATION')
        //     this.certificationCategoryCheckboxItems.forEach((certItem) => { certItem.checked = true; });
        this.minimiseAnbieter = false;
    }

    isOrgInCategory(org: MarketplaceCheckbox): boolean {
        if (this.marketScreenState === 'PRODUCT') {
            if (this.getCurrentRoute().includes('category=Software'))
                return this.orgaProductsFromFilter.find(x => x.id == org.id).hasActiveSoftwareProduct;
            else if (this.getCurrentRoute().includes('category=Datenbanken'))
                return this.orgaProductsFromFilter.find(x => x.id == org.id).hasActiveDatabaseProduct;
            else if (this.getCurrentRoute().includes('category=Fachpublikationen'))
                return this.orgaProductsFromFilter.find(x => x.id == org.id).hasActiveSpecPubProduct;
        }
        return true;
    }

    showAllCertOrganisation(event: MatCheckboxChange) {
        this.limitCheckboxesToOne(OrganisationType.CERTIFICATION_PROVIDER, 0);
        this.certificationCategoryCheckboxItems.forEach(certificationOrganisationCategory => {
            if (certificationOrganisationCategory.value === 'ATTRIBUTE_CERT' || certificationOrganisationCategory.value === 'PTG_CERT') {
                this.attributeCertificationOrganisationCheckBoxes.forEach(checkbox => {
                    this._receiveCheckedValue(checkbox, event);
                    this.toggleProductCheckBoxes(checkbox.categorie, false);
                });
                this.ptgCertificationOrganisationCheckBoxes.forEach(checkbox => {
                    this._receiveCheckedValue(checkbox, event);
                    this.toggleProductCheckBoxes(checkbox.categorie, false);
                });
            }
        });
    }

    getActiveEntryCount(commonFeature: FilterCommonFeature): number {
        let count = commonFeature.entries
            ?.filter(e => e.isChecked && !e.name.includes(';'))
            .length ?? 0;
        const fachPlanerParent = commonFeature.entries?.find(e => e.id === this.fachPlanerId);
        if (fachPlanerParent?.isChecked) {
            count += this.fachPlanerEntries.filter(e => e.isChecked).length;
        }
        return count;
    }

    getZertActiveEntryCount(zertificationCategoryCheckboxItems: MarketplaceCheckbox[]): number {
        let count = zertificationCategoryCheckboxItems
            ?.filter(e => e.isChecked && !e.label.includes(';'))
            .length ?? 0;
        const fachPlanerParent = zertificationCategoryCheckboxItems?.find(e => e.id === this.fachPlanerId);
        if (fachPlanerParent?.isChecked) {
            count += this.fachPlanerEntries.filter(e => e.isChecked).length;
        }
        return count;
    }
    getptgActiveEntryCount(ptg: MarketplaceCheckbox[]): number {
        let count = ptg
            ?.filter(e => e.isChecked && !e.label.includes(';'))
            .length ?? 0;
        const fachPlanerParent = ptg?.find(e => e.id === this.fachPlanerId);
        if (fachPlanerParent?.isChecked) {
            count += this.fachPlanerEntries.filter(e => e.isChecked).length;
        }
        return count;
    }

    getRatingActiveCount(): number {
        return this.productRatingCheckboxItem
            .filter(item => item.checked)
            .length;
    }

    getOrganisationActiveCount(): number {
        return this.organisationCheckboxes
            ?.filter(org => org.isChecked && this.isOrgInCategory(org))
            .length ?? 0;
    }
}
